import { poiTypes } from "../../../../server/lib/open-planet/poiTypes";

const keys = {
  drinking_nightlife: "drinking_nightlife",
  eating: "eating",
  sleeping: "sleeping",
};

const types = {
  [keys.drinking_nightlife]: {
    Coffee: "CafeOrCoffeeShop",
    Cafe: "CafeOrCoffeeShop",
    Teahouse: "CafeOrCoffeeShop",
    Winery: "Winery",
    Vineyard: "Winery",
    Juice: "FoodEstablishment",
    "Juice Bar": "FoodEstablishment",
    Club: "NightClub",
    Distillery: "Distillery",
    Brewery: "Brewery",
    Microbrewery: "Brewery",
    Karaoke: "EntertainmentBusiness",
  },
  [keys.eating]: {
    Bakery: "Bakery",
    Pastries: "Bakery",
    Patisserie: "Bakery",
    Cafe: "CafeOrCoffeeShop",
    "Fast Food": "FastFoodRestaurant",
    "Ice Cream": "IceCreamShop",
    Market: "GroceryStore",
    Supermarket: "GroceryStore",
  },
  [keys.sleeping]: {
    "b&b": "BedAndBreakfast",
    "bed and breakfast": "BedAndBreakfast",
    resort: "Resort",
    motel: "Motel",
    hotel: "Hotel",
    hostel: "Hostel",
    residence: "Residence",
    apartment: "Apartment",
    campground: "Campground",
    "boutique hotel": "Hotel",
    "historic hotel": "Hotel",
    "5 star hotel": "Hotel",
    "4 star hotel": "Hotel",
    "3 star hotel": "Hotel",
    "2 star hotel": "Hotel",
  },
};

export default function schemaType(type, subtypes) {
  const typeOfPoi = types[type];

  if (typeof typeOfPoi === "undefined") {
    return "";
  }

  if (typeOfPoi && typeof typeOfPoi[subtypes[0]] === "undefined") {
    return poiTypes[type].schemaType;
  }

  return typeOfPoi[subtypes[0]];
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schemaType.js